import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

import formatString from '../../utils/formatString';
import { Icons } from './Icons';

const Stat = ({ label, value, accent }) => (
	<div className={`dn-stat${accent ? ' dn-stat--accent' : ''}`}>
		<div className='dn-stat-label'>{label}</div>
		<div className='dn-stat-value'>{value ?? '—'}</div>
	</div>
);

Stat.propTypes = {
	label: PropTypes.node.isRequired,
	value: PropTypes.node,
	accent: PropTypes.bool,
};

const formatValue = (v) => {
	if (v === null || v === undefined) return '—';
	if (typeof v === 'number') return v.toLocaleString();
	if (typeof v === 'boolean') return v ? '✓' : '✗';
	if (typeof v === 'object') return JSON.stringify(v);
	return String(v);
};

const ReconSummary = ({ resultInfo }) => {
	const { t } = useTranslation();

	const customEntries = useMemo(() => {
		if (!resultInfo?.custom) return [];
		return Object.entries(resultInfo.custom);
	}, [resultInfo]);

	if (customEntries.length === 0) return null;

	return (
		<div className='dn-recon-summary'>
			<div className='dn-recon-summary-title'>
				<Icons.table /> {t('display.summary.title', { defaultValue: 'Recognition Summary' })}
			</div>
			<div className='dn-stats'>
				{customEntries.map(([key, value]) => (
					<Stat
						key={key}
						label={formatString(key)}
						value={formatValue(value)}
					/>
				))}
			</div>
		</div>
	);
};

ReconSummary.propTypes = {
	resultInfo: PropTypes.object.isRequired,
};

export default ReconSummary;
